'use client';

import { useEffect } from 'react';

import { useSearchParams } from 'next/navigation';

export function UpdateDataLayer() {
  const searchParams = useSearchParams();
  const siteId = searchParams.get('siteId');
  const bookingType = searchParams.get('bookingType');

  useEffect(() => {
    // Ensure dataLayer is initialized on the window object
    (window as any).dataLayer = (window as any).dataLayer || [];
    const dataLayer: Record<string, any>[] = (window as any).dataLayer;

    // Debug: Log initial dataLayer state
    console.log('Initial dataLayer:', dataLayer);

    // Push siteId to dataLayer if it doesn't already exist
    if (siteId && dataLayer && !dataLayer.some((item) => 'siteId' in item && item.siteId === siteId)) {
      dataLayer.push({ siteId });
      console.log('Pushed to dataLayer:', { siteId });
    }

    // Push bookingType to dataLayer if it doesn't already exist
    if (
      bookingType &&
      dataLayer &&
      !dataLayer.some((item) => 'bookingType' in item && item.bookingType === bookingType)
    ) {
      dataLayer.push({ bookingType });
      console.log('Pushed to dataLayer:', { bookingType });
    }

    // Debug: Log updated dataLayer state
    console.log('Updated dataLayer:', dataLayer);
  }, [siteId, bookingType]);

  return null;
}
